import script from "./ReportPageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPageFooter.vue?vue&type=script&setup=true&lang=js"

import "./ReportPageFooter.vue?vue&type=style&index=0&id=8a05ab74&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a05ab74"]])

export default __exports__